import { useAppDispatch } from "@/shared/lib/redux"
import { IUser } from "@/shared/api/users"
import { ChangedUserGroup } from "../../model/types"
import { 
    openChangeUserGroupModal as openChangeUserGroupModalAction ,
    closeChangeUserGroupModal as closeChangeUserGroupModalAction
} from '../../model'

export const useChangeUserGroupModal = () => {
    const dispatch = useAppDispatch()

    const openChangeUserGroupModal = (user: IUser, onSuccess?: (group: ChangedUserGroup | null) => void) => {
        dispatch(openChangeUserGroupModalAction({
            data: user,
            onSuccess
        }))
    }

    const closeChangeUserGroupModal = () => {
        dispatch(closeChangeUserGroupModalAction())
    }
    
    return {
        openChangeUserGroupModal,
        closeChangeUserGroupModal
    }
}

